import React from "react";
import styled, { keyframes } from "styled-components";

// Keyframes for shimmer animation
const shimmerKeyframe = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

// Shimmer effect container
const SkeletonBox = styled.div`
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 1000px 104px;
  animation: ${shimmerKeyframe} 1.2s infinite linear;
  border-radius: ${(props) => props.rounded || "4px"};
  height: ${(props) => props.h || "20px"};
  width: ${(props) => props.w || "100%"};
  margin-bottom: ${(props) => props.mb || "0"};
`;

const SkeletonWrapper = styled.div`
  padding: 10px 150px 150px 150px;
  gap: 15px;
  display: flex;
  flex-direction: column;
`;

const SkeletonCard = styled.div`
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 20px;
`;

const Stepper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 20px 20px 20px 20px;
  justify-content: flex-end;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  gap: 15px;
`;

const OccupantHomePageShimmer = () => {
  return (
    <>
      <SkeletonBox h="50px" w="100%" mb="8px" />
      <Stepper>
        {[...Array(1)].map((_, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <SkeletonBox h="35px" w="250px" />
            <SkeletonBox h="35px" w="250px" />
          </div>
        ))}
      </Stepper>
      <SkeletonWrapper>
        {/* Stepper */}

        <SkeletonCard>
          <Wrapper>
            <SkeletonBox h="30px" w="250px" mb="8px" />
            <SkeletonBox h="400px" w="100%" />
          </Wrapper>
        </SkeletonCard>
        <SkeletonBox h="30px" w="250px" mb="8px" />
        <SkeletonCard>
          <Wrapper>
            <SkeletonBox h="400px" w="100%" />
          </Wrapper>
        </SkeletonCard>
        <SkeletonBox h="30px" w="250px" mb="8px" />
        <SkeletonCard>
          <Wrapper>
            <SkeletonBox h="400px" w="100%" />
          </Wrapper>
        </SkeletonCard>
      </SkeletonWrapper>
    </>
  );
};

export default OccupantHomePageShimmer;
